const statusConfig = {
  draft: { label: "Brouillon", class: "status-draft" },
  in_progress: { label: "En cours", class: "status-in-progress" },
  completed: { label: "Terminé", class: "status-completed" },
  archived: { label: "Archivé", class: "status-archived" },
  en_attente: { label: "En attente", class: "status-draft" },
  en_cours: { label: "En cours", class: "status-in-progress" },
  termine: { label: "Terminé", class: "status-completed" },
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || { label: status, class: "status-draft" };
  
  return (
    <span className={`status-badge ${config.class}`} data-testid={`status-${status}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
